import { ArslActionSetRowHeight, ArsListingState } from "../interface";

/**
 * Updates the configured height for a single listing body row.
 *
 * @param state - Current ARS listing state
 * @param action - Set-row-height action describing the target row and height
 * @returns Updated ARS listing state with the row height applied
 */
export const arsl_setRowHeight = <T>(
  state: ArsListingState<T>,
  action: ArslActionSetRowHeight,
): ArsListingState<T> => ({
  ...state,
  changed: true,
  bodyData: {
    ...state.bodyData,
    arsBodyRows: state.bodyData.arsBodyRows.map((row) =>
      row.id === action.rowId ? { ...row, rowHeight: action.rowHeight } : row,
    ),
  },
});
